import { fetchWithAuth } from "./FetchHelper";

const apiUrl = process.env.REACT_APP_API_URL;
export const GetUsuarisIdJutgeNotes = async (id_user: string) => {
    try {
        const response = await fetchWithAuth(`${apiUrl}:8061/usuaris/${id_user}/jutge/notes`);
        if (response && response.ok) {
            return await response.json();
        }
        return [];
    } catch (error) {
        console.log('Error al obtener los datos:', error);
        return [];
    }
};
